import type { FormDrawerProps } from '../../FormDrawer';
import { MorningConfigurationFooter } from './components/MorningConfigurationFooter';
import { MorningConfigurationForm } from './components/MorningConfigurationForm';
import { MorningConfigurationFormSchema } from './MorningConfigurationFormSchema';

export const ConfigureMorningComponents: FormDrawerProps = {
  zodSchema: MorningConfigurationFormSchema,
  ContentComponent: MorningConfigurationForm,
  Footer: MorningConfigurationFooter,
};